import { useEffect, useState } from 'react';
import { generateFormField } from '../../../utils/form/generate-form-fields/generate-form-fields';
import { errorMessages } from '../../../utils/error-messages';
import { ConfigurationFromPdfFieldNames } from '../configuration-from-pdf.types';
import cloneDeep from 'lodash/cloneDeep';
import { UseFormReturn } from 'react-hook-form';
import { GenerateFormFieldReturn } from '../../../utils/form/generate-form-fields/generate-form-fields.props';
import { AnyObject, User } from '../../../common/interfaces';
import {
  getCompanyActiveCars,
  getCompanyActiveCarsForPoolManager,
  getDriversActiveCars
} from '../get-drivers-active-cars';
import { getResponseFormData } from '../../../utils/get-response-data';
import { useLocation } from 'react-router-dom';
import { PAGES } from '../../../common/enums';
import { useIsUserHaveRole } from '../../../hooks/use-is-user-have-role';
import { USER_ROLES } from '../../../constants';
import { useTypedSelector } from '../../../hooks/use-typed-selector';

const useOldCarFields = (isReplacementCar: boolean, reactHookFormData: UseFormReturn) => {
  const location = useLocation();
  const isPoolManager = useIsUserHaveRole(USER_ROLES.poolManager.id);
  const user = useTypedSelector<User>(state => state['app'].user);

  const [oldCarFields, setOldCarFields] = useState<GenerateFormFieldReturn[]>([
    generateFormField.lookup({
      label: 'Altes Fahrzeug',
      name: ConfigurationFromPdfFieldNames.OldCar,
      disabled: false,
      options: undefined,
      validation: {
        required: errorMessages.requiredOptionSet
      }
    })
  ]);

  const { setValue, clearErrors } = reactHookFormData;

  const isMitarbeiterkonfigurationenPage = location.pathname.includes(PAGES.EMPLOYEE_CONFIGURATIONS);

  useEffect(() => {
    const newOldCarFormFields = cloneDeep(oldCarFields);
    let getCarsFunction = getDriversActiveCars;
    if (isMitarbeiterkonfigurationenPage) {
      getCarsFunction = isPoolManager ? getCompanyActiveCarsForPoolManager : getCompanyActiveCars;
    }

    getCarsFunction(user).then(response => {
      const cars = (getResponseFormData(response.data, [{ name: 'entityes', type: 'array' }]) as AnyObject[]).map(
        item => ({
          value: item.new_fuhrparkid,
          label: item.new_name
        })
      );
      newOldCarFormFields[0].options = cars;
      if (!isMitarbeiterkonfigurationenPage) {
        newOldCarFormFields[0].disabled = cars.length === 1;
        newOldCarFormFields[0].defaultValue = cars.length === 1 ? cars[0].value : '';
        setValue(ConfigurationFromPdfFieldNames.OldCar, cars[0].value);
      }
      setOldCarFields(newOldCarFormFields);
    });
  }, []);

  useEffect(() => {
    if (!oldCarFields?.[0]?.options) {
      return;
    }
    const newOldCarFields = cloneDeep(oldCarFields);
    newOldCarFields[0].disabled = isReplacementCar || newOldCarFields[0].options?.length === 1;
    newOldCarFields[0].validation.required = isReplacementCar ? false : errorMessages.requiredOptionSet;
    setOldCarFields(newOldCarFields);
  }, [isReplacementCar, !!oldCarFields]);

  useEffect(() => {
    if (oldCarFields?.[0]?.disabled && !oldCarFields?.[0]?.defaultValue) {
      setValue(ConfigurationFromPdfFieldNames.OldCar, '');
      clearErrors(ConfigurationFromPdfFieldNames.OldCar);
    }
  }, [oldCarFields?.[0]?.disabled]);

  return { oldCarFields };
};

export default useOldCarFields;
